<card-expanding
  [formGroup]="form"
  [valid]="productValidity.getCardStatusValidType(cardSection)"
  [expanded]="isExpanded"
  (onExpand)="saveLocalExpandedValue($event)"
>
  <span header-title>{{ title | translate}}</span>

  <div header-actions *requiredRights="[UserAction.ManageProducts]">
    <ng-container *ngIf="isOwnProduct">
      <locked-info *ngIf="!edit && locked" [locked]="locked"></locked-info>

      <ng-container *ngIf="!edit && !locked">
        <lxm-button
          type="beige"
          icon="edit"
          title="action.edit"
          (click)="toggleEdit()"
        ></lxm-button>
      </ng-container>

      <ng-container *ngIf="edit">
        <lxm-button
          type="grey"
          icon="back"
          label="action.cancel"
          (click)="toggleEdit()"
        >
        </lxm-button>
        <lxm-button
          type="beige"
          icon="save"
          label="action.save"
          [loading]="saveLoading"
          (click)="save()"
        ></lxm-button>
      </ng-container>
    </ng-container>
  </div>

  <div body>
    <div class="grid w-full grid-cols-1 gap-4 xl:grid-cols-2">
      <div class="flex flex-col">
        <form-field
          [readonly]="!edit"
          label="cards.products.product_attributes.label.product_attributes"
          description="cards.products.product_attributes.label_description.product_attributes"
          for="attributes"
          [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Attributes, form.get('attributes').value?.length > 0)"
        >
          <lxm-select
            select
            for="attributes"
            class="w-full"
            [options]="attributeOptions"
            value="id"
            labelField="translatedValue"
            [isTranslated]="true"
            [searchable]="true"
            [multiple]="true"
            [sortByLabel]="true"
            [readonly]="!edit"
          >
          </lxm-select>
          <validation-errors for="attributes"></validation-errors>
        </form-field>
      </div>
    </div>
  </div>
</card-expanding>
